import { Link } from "react-router-dom"
import { MessageSquare } from "lucide-react"
export function Footer() {
  return (
    <>
      <footer className="py-12 text-white bg-brand-nickel">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2">
                <Link to="/">
                  <img
                    src="/images/white-logo.png"
                    alt="Pranaam Hospitals Logo"
                    width={120}
                    height={60}
                    className="h-12 w-auto"
                  />
                </Link>
              </div>
              <p className="text-white/90 mb-4">
                Providing compassionate care and cutting-edge medical services to our community.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/about" className="text-white/80 hover:text-white transition-colors">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/doctors" className="text-white/80 hover:text-white transition-colors">
                    Our Doctors
                  </a>
                </li>
                <li>
                  <a href="/services" className="text-white/80 hover:text-white transition-colors">
                    Services
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-white/80 hover:text-white transition-colors">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Services</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/services/cardiology" className="text-white/80 hover:text-white transition-colors">
                    Cardiology
                  </a>
                </li>
                <li>
                  <a href="/services/neurology" className="text-white/80 hover:text-white transition-colors">
                    Neurology
                  </a>
                </li>
                <li>
                  <a href="/services/orthopedics" className="text-white/80 hover:text-white transition-colors">
                    Orthopedics
                  </a>
                </li>
                <li>
                  <a href="/maternity-matters" className="text-white/80 hover:text-white transition-colors">
                    Maternity Matters
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Contact Us</h3>
              <address className="not-italic text-white/80">
                <p className="mb-2">Pranaam Hospitals</p>
                <p className="mb-2">Madinaguda, Hyderabad</p>
                <p className="mb-2">Phone: +91 99660 60000</p>
                <p className="mb-2">Email: info@pranaamhospitals.com</p>
              </address>
            </div>
          </div>

          <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/80">
            <p>&copy; {new Date().getFullYear()} Pranaam Hospitals. All rights reserved.</p>
          </div>
        </div>
      </footer>
      
    </>
  )
}
